import Decimal from "decimal.js";
import { Product, ProductComponent } from "../../types";
import { getPrice } from "../productComponent/getPrice";
import { findProductComponent } from "../productComponents/findProductComponent";

export function getComponentTotal(component: Product['components'][number], components: ProductComponent[]) : number{
    
    let _components = components;
   
    
    const match = findProductComponent(_components, component.id)
    if(!match){
        //throw new Error(`Could not find component with id ${component.id}`)
        return 0;
    }

    const componentPrice = getPrice(match, _components);
    let componentTotal = new Decimal(componentPrice).mul(component.qty).toNumber();
    if(component.margin){
        componentTotal = new Decimal(componentTotal).div(1 - component.margin / 100).toNumber();
    }

    return componentTotal;
}